<template>
    <v-container class="ma-0 pa-0 pb-8">
        <v-row class="pt-10 px-8 pb-12">
            <strong>Filtros</strong>
            <v-spacer></v-spacer>
            <v-btn @click="removeFilter()" small class="elevation-0" style="border:solid 1px #dddddd;">
                <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
            </v-btn>

            <v-autocomplete @keydown.enter="filter()" v-model="activity.company_id" :items="companyLists" :loading="isLoadingCompany" :search-input.sync="searchCompanies" hide-no-data item-value="id" item-text="name" :label="liga!='https://backendbdb.unocrm.mx/'?'Empresa(s)':'Cliente'" placeholder="Escribe para buscar" attach chips multiple>
                <template v-slot:item="{item, attrs, on}">
                    <v-list-item v-on="on" v-bind="attrs">
                        <v-list-item-content>
                            <v-list-item-title v-if="item.name!=null">
                                <span v-if="item.macro!=null">{{item.macro}}</span>{{item.name}}
                                <div v-if="item.razon_social!=null">
                                    <span style="font-size:12px;">{{item.razon_social}}</span>
                                </div>
                            </v-list-item-title>
                            <v-list-item-title v-else-if="item.razon_social!=null">
                                {{item.razon_social}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template> 
            </v-autocomplete>

            <v-autocomplete @keydown.enter="filter()" v-model="activity.contact_id" :items="contactList" :loading="isLoadingContact" :search-input.sync="searchContacts" hide-no-data item-value="id" item-text="name" label="Contacto(s)" v-if="liga!='https://backendbdb.unocrm.mx/'" placeholder="Escribe para buscar" attach chips multiple>
                <template v-slot:item="{item, attrs, on}">
                    <v-list-item v-on="on" v-bind="attrs">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{item.name}} <span v-if="item.last!=undefined">{{item.last}}</span>
                                <div>
                                    <span style="font-size:12px;">{{item.company}}</span>
                                </div>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template> 
            </v-autocomplete>

            <v-autocomplete @keydown.enter="filter()" v-model="activity.sales_man" :items="userList" hide-no-data item-value="id" item-text="name" label="Vendedor(es)" placeholder="Escribe para buscar" attach chips multiple></v-autocomplete>
            <v-autocomplete @keydown.enter="filter()" v-model="activity.user_id" :items="userList" hide-no-data item-value="id" item-text="name" label="Usuario(s)" placeholder="Escribe para buscar" attach chips multiple></v-autocomplete>
            <v-autocomplete @keydown.enter="filter()" v-model="activity.created_by_user_id" :items="userList" hide-no-data item-value="id" item-text="name" label="Creador(es)" placeholder="Escribe para buscar" attach chips multiple></v-autocomplete>
            <v-autocomplete @keydown.enter="filter()" v-model="activity.last_updated_by_user_id" :items="userList" hide-no-data item-value="id" item-text="name" label="Editor(es)" placeholder="Escribe para buscar" attach chips multiple></v-autocomplete>

            <v-menu offset-y :close-on-content-click="closeDatePicker(activity.date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="activity.date" label="Fecha" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="activity.date" range></v-date-picker>
            </v-menu>

            <v-menu offset-y :close-on-content-click="closeDatePicker(activity.created_at)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="activity.created_at" label="Fecha Creación" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="activity.created_at" range></v-date-picker>
            </v-menu>

            <v-menu offset-y :close-on-content-click="closeDatePicker(activity.updated_at)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="activity.updated_at" label="Fecha Edición" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="activity.updated_at" range></v-date-picker>
            </v-menu>

            <v-select @keydown.enter="filter()" label="Realizada" v-model="activity.completed" :items="statuses"></v-select>

            <v-text-field @keydown.enter="filter()" label="Descripción" v-model="activity.description"></v-text-field>

        </v-row>
        <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
            <v-list-item link @click="filter()" dark>
                <v-list-item-content>
                    <strong>Filtrar (0)</strong>
                </v-list-item-content>
            </v-list-item>    
        </v-card>
    </v-container>
</template>

<script>
import axios from "axios";

const emptyActivityFilters = () => ({
    company_id: [],
    contact_id: [],
    user_id: [],
    created_by_user_id: [],
    last_updated_by_user_id: [],
    sales_man: [],
    description: '',
    completed: '',
    date: [],
    created_at: [],
    updated_at: [],
});

const selectedIds = (value) => {
    const values = Array.isArray(value) ? value : [value];

    return values.filter(value => value !== undefined && value !== null && value !== '' && value !== 'undefined');
};

export default {
    data: () => ({
        statuses:[{text:'Realizado', value:1}, {text:'No Realizado', value:0}],//{text:'Pendiente', value:'Pending'}, 
        activity: emptyActivityFilters(),
        entries:{
            companies: [],
            contacts:[]
        },
        isLoadingCompany: false,
        isLoadingContact: false,
        searchCompanies: null,
        searchContacts: null,
    }),
    watch: {
        currentUser: {
            handler(){
                this.applyDefaultUserFilter();
            },
            immediate: true,
            deep: true,
        },
        searchCompanies(val){
            //if (this.companyLists.length > 0) return
            if (this.isLoadingCompany) return
            this.isLoadingCompany = true
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/company_p?filter[name]='+val)
            .then(res => {
                this.entries.companies = res.data.data
            }).finally(() => (this.isLoadingCompany = false))
        },
        searchContacts(val){
            //if (this.contactList.length > 0) return
            if (this.isLoadingContact) return
            this.isLoadingContact = true

            const companyIds = selectedIds(this.activity.company_id);
            const length = companyIds.length;
            let filter = '';
            if(length>0){
                filter = 'filter[company_id]='
                for(var i=0; i<length; i++){
                    filter = filter + companyIds[i]
                    if(length>1 && i<length-1){
                        filter = filter + ','
                    }else{
                        filter = filter + "&"
                    }
                }
            }
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/contact_p?' + filter + "filter[name]=" + val)
            .then(res => {
                this.entries.contacts = res.data.data
            }).finally(() => (this.isLoadingContact = false))
        },
    },
    computed:{
        liga(){
            return process.env.VUE_APP_BACKEND_ROUTE
        },
        companyLists(){
            if(this.entries!=null){
                return this.entries.companies.map(id => {
                    return{
                        id:id.id,
                        macro:id.macro,
                        name:id.name,
                        razon_social:id.razon_social
                    }
                })
            }
            return [];
        },
        contactList(){
            if(this.entries!=null){
                return this.entries.contacts.map(id => {
                    return{
                        id:id.id,
                        name:id.name,
                        last:id.last,
                        company:id.company.name,
                        job_position:id.job_position
                    }
                })
            }
            return [];
        },
        userList(){
            return this.$store.state.user.users.map(id => {
                return{
                    id:id.id,
                    name:id.name + id.last,
                }
            })
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user
            }
        },
    },
    created(){
        this.restoreFilters();
        this.applyDefaultUserFilter();
    },
    methods:{
        restoreFilters(){
            const storedFilters = localStorage.getItem('selectorFiltersActivities');
            const storedEntries = localStorage.getItem('entriesFiltersActivities');

            if(storedFilters){
                try {
                    const filters = JSON.parse(storedFilters);

                    if(filters && typeof filters === 'object' && !Array.isArray(filters)){
                        this.activity = {
                            ...emptyActivityFilters(),
                            ...filters,
                            company_id: selectedIds(filters.company_id),
                            contact_id: selectedIds(filters.contact_id),
                            user_id: selectedIds(filters.user_id),
                            created_by_user_id: selectedIds(filters.created_by_user_id),
                            last_updated_by_user_id: selectedIds(filters.last_updated_by_user_id),
                            sales_man: selectedIds(filters.sales_man),
                            date: selectedIds(filters.date),
                            created_at: selectedIds(filters.created_at),
                            updated_at: selectedIds(filters.updated_at),
                        };
                    }
                } catch (error) {
                    localStorage.removeItem('selectorFiltersActivities');
                }
            }

            if(storedEntries){
                try {
                    const entries = JSON.parse(storedEntries);
                    if(entries && typeof entries === 'object'){
                        this.entries = entries;
                    }
                } catch (error) {
                    localStorage.removeItem('entriesFiltersActivities');
                }
            }
        },
        applyDefaultUserFilter(){
            const userId = this.currentUser && this.currentUser.id;

            if(userId && Number(userId) !== 1 && Number(userId) !== 6 && selectedIds(this.activity.user_id).length === 0){
                this.activity.user_id = [userId];
            }
        },
        appendFilter(filters, key, value){
            if(Array.isArray(value)){
                const ids = selectedIds(value);
                if(ids.length === 0){
                    return;
                }

                filters.push(`filter[${key}]=${encodeURIComponent(ids.join(','))}`);
                return;
            }

            if(value !== undefined && value !== null && String(value).trim() !== '' && value !== 'undefined'){
                filters.push(`filter[${key}]=${encodeURIComponent(value)}`);
            }
        },
        closeDatePicker(dates){
            if(dates!=undefined && dates.length==2){
                return true
            }else{
                return false
            }
        },
        filter(){
            const filters = [];

            this.appendFilter(filters, 'description', this.activity.description);
            this.appendFilter(filters, 'company_id', this.activity.company_id);
            this.appendFilter(filters, 'contact_id', this.activity.contact_id);
            this.appendFilter(filters, 'created_by_user_id', this.activity.created_by_user_id);
            this.appendFilter(filters, 'last_updated_by_user_id', this.activity.last_updated_by_user_id);
            this.appendFilter(filters, 'user_id', this.activity.user_id);
            this.appendFilter(filters, 'company.user_id', this.activity.sales_man);
            this.appendFilter(filters, 'completed', this.activity.completed);

            if(selectedIds(this.activity.date).length === 2){
                this.appendFilter(filters, 'date_between', selectedIds(this.activity.date));
            }
            if(selectedIds(this.activity.created_at).length === 2){
                this.appendFilter(filters, 'created_between', selectedIds(this.activity.created_at));
            }
            if(selectedIds(this.activity.updated_at).length === 2){
                this.appendFilter(filters, 'updated_between', selectedIds(this.activity.updated_at));
            }

            const filter = filters.length ? `&${filters.join('&')}` : '';
            const count = filters.length;
            localStorage.setItem('selectorFiltersActivities', JSON.stringify(this.activity));
            localStorage.setItem('entriesFiltersActivities', JSON.stringify(this.entries));
            localStorage.setItem('filtersActivities', JSON.stringify(filter));
            localStorage.setItem('filtersActivitiesLength', count)

            this.$nextTick(() => {
                this.$emit("filtersActivities", false);
            })
        },
        removeFilter(){
            this.activity = emptyActivityFilters();
            this.applyDefaultUserFilter();
            this.entries = {
                companies: [],
                contacts:[]
            };
            localStorage.removeItem("selectorFiltersActivities");
            localStorage.removeItem("filtersActivities");
            localStorage.removeItem("entriesFiltersActivities");
            localStorage.removeItem("filtersActivitiesLength");
            this.$nextTick(() => {
                this.$emit("filtersActivities", false);
            })
        }
    }
}
</script>
